<div class="warningContainer">
	<div class="warningTitle">
		<h2 class="accent">{{ warningTitle() | translate }}</h2>
	</div>

	<div class="warningDescription">
		{{ warningDescription() | translate }}
	</div>

	<div class="warningIcon">
		<i class="fad fa-sad-tear fa-8x"></i>
	</div>

	@if (warningActions.children?.length) {
		<mat-divider class="warningActionsDivider" />
	}

	<div class="warningActions" #warningActions>
		<ng-content select="[actions]" />
	</div>
</div>
